import * as DemoActions from './app.actions';
import { WebSiteContent } from './app.modal';

const initialState: WebSiteContent = {
    data: null,
    productDetailPageData: null,
    userRegPageData: null,
    currentActivePromo: null
};

export function reducer(state: WebSiteContent = initialState, action: DemoActions.Actions): WebSiteContent {
    switch (action.type) {
        case DemoActions.ADD_DEMO:
            return {
                ...state,  // Keep existing state values
                ...action.data  // Update only the provided fields
            };

        case DemoActions.REMOVE_DEMO:
            return initialState; // Reset state if needed, or handle differently

        default:
            return state;
    }
}